import * as React from "react";
import MedicineChartPage from "../../../medicinechart/pages/MedicineChartPage";


export default function MedicineChartSchedulePage() {
  return (
    <h1>
      <MedicineChartPage/>
    </h1>
  );
}